@use '@/scss/underscore' as _;

.connectorContainer {
  flex: 1;
}
